<div class="card d-flex fd-col jc-center ai-center">
  <h4>
    <mat-icon>add</mat-icon>
  </h4>
  <h4>New Tile.</h4>
  <p>This is a new tile with no definition!</p>
</div>